import leanplum from 'leanplum-sdk';
import { APP_ID, ACCESS_KEY } from './pushNotificationService-const';
import { logger } from '../util/index';

const registerForPush = () => {
  const isWebPushSupported = leanplum.isWebPushSupported();
  if (isWebPushSupported) {
    leanplum.isWebPushSubscribed().then((subscriptionStatus) => {
      if (isWebPushSupported && !subscriptionStatus) {
        leanplum.registerForWebPush('./sw.min.js');
        logger.info('Leanplum: subscriptionStatus', subscriptionStatus);
      }
    });
  }
};

export const registerForPushSubscription = () => {
  leanplum.setAppIdForProductionMode(APP_ID, ACCESS_KEY);

  leanplum.start(() => {
    registerForPush();
  });
};

export const checkSubscriptionAvailability = leanplum.isWebPushSupported;
export const checkSubscriptionStatus = leanplum.isWebPushSubscribed;
